import TableWithTitle from "@/components/TableWithTitle.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange, getColorForDecile } from "@/utils/transformers";
import { capitalizeWords } from "@/utils";
import { DSP_OVERVIEW_CAMPAIGN_GOAL, DSP_OVERVIEW_BUDGET, DSP_OVERVIEW_SPEND, DSP_OVERVIEW_DELIVERY_RATE, DSP_OVERVIEW_OBJECTIVE, DSP_OVERVIEW_CPA, DSP_OVERVIEW_OPTIMIZATION_KPI, DSP_OVERVIEW_ASSISTED_SALES, DSP_OVERVIEW_ASSISTED_UNITS_SOLD } from "@/utils/table_fields";
import AppIcon from "@/components/AppIcon.vue";
import CoinsSwapIcon from "@/components/icons/CoinsSwapIcon.vue";
import UserPlusIcon from "@/components/icons/UserPlusIcon.vue";
import rssIcon from "@/components/icons/rssIcon.vue";
import AnnoncementIconSmall from "@/components/icons/AnnoncementIconSmall.vue";
import { mapState, mapActions } from "vuex";
import { HugValue, DateValue, CurrencyValue, NumberValue, PercentageValue, BoxedValue, BarWithValue, OverlapBarValue, DotElement } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import { EVENTS, DEFAULT_DATE_FORMATS, PERIOD_COLUMN_TITLES, ECPM_DECILE_COLORS, DSP_DELIVERY_RATE_BG_COLORS, DSP_DELIVERY_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_BG_COLORS } from "@/utils/constants";
import FlexRow from "@/components/FlexRow.vue";
import moment from "moment";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
import ProductTableTotal from "@/components/dsp_report/ProductTableTotal.vue";
export default {
  name: "ConversionPeriodTable",
  components: {
    HugValue,
    DateValue,
    CurrencyValue,
    NumberValue,
    PercentageValue,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TextValue,
    WrapWithPopover,
    TableWithTitle,
    FlexRow,
    AppIcon,
    BoxedValue,
    BarWithValue,
    OverlapBarValue,
    DotElement,
    ProductTableTotal,
    CoinsSwapIcon,
    UserPlusIcon,
    rssIcon,
    AnnoncementIconSmall
  },
  mixins: [LiteTableMixin],
  props: {
    loading: {
      typ: Boolean,
      required: true
    }
  },
  data() {
    return {
      PERIOD_COLUMN_TITLES,
      ECPM_DECILE_COLORS,
      DSP_DELIVERY_RATE_BG_COLORS,
      DSP_DELIVERY_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_BG_COLORS,
      fields: [DSP_OVERVIEW_CAMPAIGN_GOAL, DSP_OVERVIEW_BUDGET, DSP_OVERVIEW_SPEND, DSP_OVERVIEW_DELIVERY_RATE, DSP_OVERVIEW_OBJECTIVE, DSP_OVERVIEW_CPA, DSP_OVERVIEW_OPTIMIZATION_KPI, DSP_OVERVIEW_ASSISTED_SALES, DSP_OVERVIEW_ASSISTED_UNITS_SOLD]
    };
  },
  computed: {
    ...mapState({
      overviewTable: state => state.dsp_report.overviewTable,
      period: state => state.dsp_report.overview_period
    }),
    items() {
      return this.overviewTable.items;
    },
    maxCharCount() {
      return this.overviewTable.maxCharCount;
    },
    minMax() {
      return this.overviewTable.minMax;
    }
  },
  methods: {
    ...mapActions(["dspFetchOverviewTableData"]),
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    capitalizeWords,
    getColorForDecile,
    handleRowClick(item) {},
    getBreakdownPerGoal(goal) {
      const breakdownMap = {
        'Repurchases': ['breakdown_a', 'breakdown_b'],
        'New Customers': ['breakdown_a', 'breakdown_b'],
        'Consideration Signals': ['breakdown_a', 'breakdown_b', 'breakdown_c', 'breakdown_d']
      };
      return breakdownMap[goal] ?? [];
    }
  }
};